module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-right-80ecb097cf72fcfea9a210ffe3345898.svg";